import React from 'react';
import { TelemetryGapZone as GapZoneType } from '../utils/telemetry-grid.utils';

export interface TelemetryGapZoneProps {
  gap?: GapZoneType;
  mode?: 'grid' | 'list';
  onInsert?: (gap: GapZoneType) => void;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Unified Telemetry Gap Zone Component
 * Renders gap insertion lines & + badges for both Grid and List layout modes.
 */
export const TelemetryGapZoneUI: React.FC<TelemetryGapZoneProps> = ({
  gap,
  mode = 'grid',
  onInsert,
  className = '',
  style,
}) => {
  if (mode === 'list') {
    return (
      <div
        onClick={() => onInsert && onInsert(gap as GapZoneType || { key: 'gap-list', orient: 'h', panelW: 12, panelH: 3, y: 0, left: 0, top: 0, width: 0, height: 0 })}
        className={`gap-zone td-gap-zone td-gap-zone--list ${className}`}
        style={style}
      >
        <div className="gap-zone-line" />
        <div className="gap-zone-badge td-gap-zone-badge">+</div>
      </div>
    );
  }

  if (!gap) return null;

  return (
    <div
      key={gap.key}
      onClick={() => onInsert && onInsert(gap)}
      className={`gap-zone td-gap-zone ${className}`}
      style={{
        left: gap.left,
        top: gap.top,
        width: gap.width,
        height: gap.height,
        ...style,
      }}
    >
      <div
        className="gap-zone-line"
        style={{
          width: gap.orient === 'v' ? 2 : '100%',
          height: gap.orient === 'h' ? 2 : '100%',
        }}
      />
      <div className="gap-zone-badge td-gap-zone-badge">+</div>
    </div>
  );
};
